class GoldDriveFaqGroup extends HTMLElement {
  #versions = new WeakMap();

  connectedCallback() {
    if (this.dataset.faqReady === 'true') return;

    this.dataset.faqReady = 'true';
    this.#keepSingleInitialItemOpen();
    this.querySelectorAll('.gd-home__faq').forEach((item) => {
      item.dataset.faqEnhanced = 'true';
      item.dataset.expanded = item.open ? 'true' : 'false';
      item.removeAttribute('name');
    });
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #keepSingleInitialItemOpen() {
    const openItems = [...this.querySelectorAll('.gd-home__faq[open]')];
    openItems.slice(1).forEach((item) => item.removeAttribute('open'));
  }

  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const summary = event.target.closest('.gd-home__faq > summary');
    if (!summary || !this.contains(summary)) return;

    event.preventDefault();
    const nextItem = summary.parentElement;
    const willOpen = nextItem.dataset.expanded !== 'true';

    if (!willOpen) {
      this.#setExpanded(nextItem, false);
      return;
    }

    this.querySelectorAll('.gd-home__faq').forEach((item) => {
      if (item !== nextItem && item.dataset.expanded === 'true') {
        this.#setExpanded(item, false);
      }
    });
    this.#setExpanded(nextItem, true);
  };

  #setExpanded(item, expanded) {
    const panel = item.querySelector('.gd-home__faq-panel');
    if (!panel) return;

    const nextVersion = (this.#versions.get(item) || 0) + 1;
    this.#versions.set(item, nextVersion);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      item.dataset.expanded = expanded ? 'true' : 'false';
      item.open = expanded;
      return;
    }

    if (expanded) {
      item.open = true;
      item.dataset.expanded = 'false';
      panel.getBoundingClientRect();
      requestAnimationFrame(() => {
        if (this.#versions.get(item) === nextVersion) {
          item.dataset.expanded = 'true';
        }
      });
      return;
    }

    item.dataset.expanded = 'false';

    const finishClosing = (event) => {
      if (event.target !== panel || event.propertyName !== 'grid-template-rows') return;

      panel.removeEventListener('transitionend', finishClosing);
      panel.removeEventListener('transitioncancel', finishClosing);
      if (this.#versions.get(item) === nextVersion && item.dataset.expanded === 'false') {
        item.open = false;
      }
    };

    panel.addEventListener('transitionend', finishClosing);
    panel.addEventListener('transitioncancel', finishClosing);
  }
}

if (!customElements.get('gold-drive-faq-group')) {
  customElements.define('gold-drive-faq-group', GoldDriveFaqGroup);
}
